import React from 'react';
import { createContainer, VictoryBar, VictoryChart, VictoryGroup, VictoryTooltip } from 'victory';
import {
  XAxis,
  YAxis,
  PluvioAxis,
} from '../../utils/helpers/view/chartsComponentHelper';
import { getBarColor } from '../../utils/helpers/view/h2sDetailHelper';

interface H2sChartComponentProps {
  display: string;
  data: any;
  colorsLegend: string[];
  pluvioData: any[];
  pluvioMax: number;
  dataMaxValue: number;
  showPluvio: boolean;
}

const H2sChartComponent = (props: H2sChartComponentProps) => {
  const VictoryZoomVoronoiContainer = createContainer('zoom', 'voronoi') as React.ComponentType<any>;
  return (
    <div
      style={{
        display: props.display,
        borderRadius: '15px',
        boxShadow: '0 14px 14px 3px rgba(18, 26, 49, 0.05)',
        backgroundColor: 'white',
        marginBottom: '15px',
      }}
    >
      <VictoryChart
        width={500}
        height={200}
        domainPadding={25}
        scale={{ x: 'time' }}
        containerComponent={
          <VictoryZoomVoronoiContainer
            labels={(datum) => {
              return `${
                datum.datum.type !== undefined ? datum.datum.type + '-' : ''
              } ${datum.datum.y} - ${new Date(datum.datum.x).toLocaleDateString(
                'fr'
              )}`;
            }}
            labelComponent={<VictoryTooltip
              style={{ fontSize: 5 }}
            />}
          />
        }
      >
        <VictoryGroup offset={5} standalone={false}>
          {props.data !== null && (
            <VictoryBar
              data={props.data}
              barWidth={0.70}
              style={{
                data: {
                  fill: ({ datum }) => getBarColor(datum),
                  width: 30,
                },
              }}
            />
          )}
          {props.showPluvio === true && props.pluvioData !== null && (
            <VictoryBar
              data={props.pluvioData}
              barWidth={0.70}
              style={{
                data: {
                  fill: 'grey',
                  width: 30,
                },
              }}
              y={(datum) => {
                return (datum.y / props.pluvioMax) * props.dataMaxValue
              }}
            />
          )}
        </VictoryGroup>
        {props.data !== null && YAxis(props, 6)}
        {XAxis()}
        {props.showPluvio === true && props.pluvioData !== null && PluvioAxis(props, 450, props.pluvioMax ,'grey', 6)}
      </VictoryChart>
    </div>
  );
};

export default H2sChartComponent;